import React from 'react';
import PropTypes from 'prop-types';
import UrCompanyListItem3 from './UrCompanyListItem3';

const getCounters = (counters) => counters.map(({ count, style, formatFunc }) => ({ count, style, formatFunc }));

export const List = ({
  data, selectedId, onSelect, aggregate
}) => (
  <div>
    {aggregate && (
    <UrCompanyListItem3
      selected={selectedId === 'all'}
      name={aggregate.title}
      counters={getCounters(aggregate.counters)}
      click={() => onSelect('all')}
      statusnew="enabled"
    />
    )}

    {data.map(({
      id, name, visited, total, accepted, counters, statusnew
    }) => (
      <UrCompanyListItem3
        key={id}
        id={id}
        name={name}
        click={id => onSelect(id)}
        selected={selectedId === id}
        counters={counters}
        statusnew={statusnew}
      />
    ))}
  </div>
);

List.defaultProps = {
  data: [],
  aggregate: null,
  selectedId: undefined
};

List.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(
    {
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }
  )),
  aggregate: PropTypes.shape({
    title: PropTypes.string.isRequired,
    counters: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number,
      formatFunc: PropTypes.func
    })).isRequired
  }),
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

export default List;



// WEBPACK FOOTER //
// ./src/components/UrCompanyList3.js